import {FC, useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { SubmitPrecertResponse } from "./types";
import { ACCEPTED_PRECERT_FILE_EXTENSIONS } from "src/constants";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";
// import NewPrecertComp from "src/components/precertComp";

const Precert: FC = (): JSX.Element => {


  const [uploadFile, changeUploadFile] = useState<FileList | null>(null);
  const navigate = useNavigate();
  const ref = useRef<HTMLInputElement>(null);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { caseId, precertsId } = useParams();
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search); // Parse query params
  const {isManufacturer}=useContext(AuthContext)

  const drugName = location.state?.drug_name;


  console.log("drugName....",drugName)


  const { loading: isFileUploading, error: submitPrecertError, data: submitPrecertData, mutate: submitPrecert } =
    useFetch<SubmitPrecertResponse>(APIEndpoints.SUBMIT_PRECERT, {}, { caseId, precertId: precertsId });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])


  useEffect(() => {
          hideLoader()

    if (submitPrecertData || submitPrecertError) {
     if(submitPrecertData) {
       showToast([`Precert Saved and Completed.`], ToastTypes.SUCCESS);
       isManufacturer ? navigate(`/todos_statistics`) : navigate(`/cases`);
     }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitPrecertData, submitPrecertError]);

  const completeMySelf = () => {
    const formData = new FormData();
    formData.append("precert[test]", "");
    if (uploadFile)
      formData.append("clinical_document", uploadFile[0]);
    formData.append("commit", "cancel");
    setLoader();
    submitPrecert(formData);
  };

  const completeOnMyBehalf = () => {
    if (uploadFile) {
      const formData = new FormData();
      formData.append("precert[test]", "");
      formData.append("clinical_document", uploadFile[0]);
      formData.append("commit", "submit_clinical_document");
      setLoader();
      submitPrecert(formData);
    }
  };





  const reset = () => {
    if (ref && ref.current) {
      ref.current.value = ""
    }
  };

  const clearDataAndForm = () => {
    changeUploadFile(null);
    reset();
  };

  const validateAndShowToast = (file: File) => {
    const caseFileExt = `.${file.name.split(".").pop()}`;
    const isExtAccepted = ACCEPTED_PRECERT_FILE_EXTENSIONS[caseFileExt];
    if (typeof isExtAccepted === "string") {
      const sizeInMBs = Number((file.size / (1024 * 1024)).toFixed(2));
      if (sizeInMBs <= 25) {
        return true;
      } else {
        showToast(["Document size should not exceed 25mb."], ToastTypes.WARNING);
      }
    } else {
      showToast(
        [`Not an acceptable format. The accepted formats are ${Object.keys(ACCEPTED_PRECERT_FILE_EXTENSIONS).toString()}`],
        ToastTypes.ERROR
      );
    }
    return false;
  };

  const handleConfirmAndExecute = (title: string, action: Function) => {
    const result = window.confirm(title);
    if (result) action();
  };

  const ConfirmAlert = (title: string, funcName: string) => {
    if (uploadFile) {
      if (validateAndShowToast(uploadFile[0])) {
        handleConfirmAndExecute(title, funcName === "completeMySelf" ? completeMySelf : completeOnMyBehalf);
      }
    } else {
      if (funcName === "completeMySelf") {
        handleConfirmAndExecute(title, completeMySelf);
      } else {
        showToast(["Document should be uploaded before submit."], ToastTypes.WARNING);
      }
    }
  };

    return (
        <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            <div className="bg-mist py-2">
                <div className="container-fluid">
                    <AuthSubHeader/>
                </div>
            </div>
            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <div className={`card-header ${drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
                    <h2 className="mb-0 page-heading">
                        Precert Detected: <small className="fs-4">Please Provide Clinical Information</small>
                    </h2>
                    {queryParam.get('insuranceName') &&
                        <p className="fw-bold m-0 fs-5">(Insurance Name: {queryParam.get('insuranceName')})</p>
                    }
                    <p>
                        We've detected the patient's insurance requires additional information to determine
                        coverage for this product, but the form is not currently available. If you wish for
                        us to complete the precert on your behalf, simply upload the patient's chart in the
                        field below.
                    </p>
                </div>
                <div className="flex-fill">
                    <div className="card">
                        <div className={`card-header ${drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
                            <h4 className="m-0">Upload Clinical Information</h4>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="input-group mb-2">
                                    <input
                                        type="file" className="form-control" id="fileUpload"
                                        onChange={(e) => changeUploadFile(e.target.files)} ref={ref}
                                    />
                                    {uploadFile ? (
                                        <button
                                            className="btn btn-primary" onClick={clearDataAndForm} type="button"
                                            id="fileUpload" disabled={isFileUploading}
                                        >
                                            Clear
                                        </button>
                                    ) : null}
                                </div>
                                <small className="d-block">
                                    Click here to upload the patient's chart. Currently we accept .txt, .pdf,
                                    .tiff, .doc, .ccd, .cda,
                                    .ccr, .ccda and image files.
                                </small>
                                <div className="d-flex mt-3 gap-2 flex-wrap">
                                    <button
                                        className="btn btn-primary" type="button" name="cancel"
                                        onClick={() => ConfirmAlert("Are you sure you would like to i will complete myself?\n This action can not be undone.", "completeMySelf")}
                                        disabled={isFileUploading}
                                    >
                                    <span
                                        data-bs-toggle="tooltip" data-bs-placement="bottom"
                                        title="This will remove the Precert Next Step from the cases screen and you will no longer be able to complete the precert below."
                                    >
                                      I Will Complete Myself
                                    </span>
                                    </button>
                                    <button
                                        className="btn btn-secondary" type="button"
                                        onClick={() => ConfirmAlert("Are you sure you would like to complete on my behalf?\n This action can not be undone.", "completeOnMyBehalf")}
                                        disabled={!uploadFile || isFileUploading}
                                    >
                                        <span
                                            data-bs-toggle="tooltip" data-bs-placement="bottom"
                                            title="We can now complete on your behalf!"
                                        >
                                          Complete On My Behalf
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <FooterText footerType="black"/>
        </div>
    );
};
export default Precert;
